/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './us';
import './ca';
import './gb';
import './au';
import './jp';
import './es';
import './ie';
import './fr';
import '../common';
import '../../onboard/activation/service';
import '../../common/messages';
import './common';
import './bic';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "external": {
                "nested": {
                  "UpdateRequest": {
                    "fields": {
                      "usBusiness": {
                        "type": "squareup.onboarding.business.UsBusiness",
                        "id": 1
                      },
                      "caBusiness": {
                        "type": "squareup.onboarding.business.CaBusiness",
                        "id": 2
                      },
                      "gbBusiness": {
                        "type": "squareup.onboarding.business.GbBusiness",
                        "id": 3
                      },
                      "auBusiness": {
                        "type": "squareup.onboarding.business.AuBusiness",
                        "id": 4
                      },
                      "jpBusiness": {
                        "type": "squareup.onboarding.business.JpBusiness",
                        "id": 5
                      },
                      "esBusiness": {
                        "type": "squareup.onboarding.business.EsBusiness",
                        "id": 6
                      },
                      "ieBusiness": {
                        "type": "squareup.onboarding.business.IeBusiness",
                        "id": 7
                      },
                      "frBusiness": {
                        "type": "squareup.onboarding.business.FrBusiness",
                        "id": 8
                      }
                    },
                    "nested": {
                      "business": {
                        "oneof": ["usBusiness", "caBusiness", "gbBusiness", "auBusiness", "jpBusiness", "esBusiness", "ieBusiness", "frBusiness"]
                      }
                    }
                  },
                  "BicPredictRequest": {
                    "fields": {
                      "businessDescription": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessExternalService": {
                    "methods": {
                      "Update": {
                        "requestType": "squareup.onboarding.business.external.UpdateRequest",
                        "responseType": "squareup.onboarding.common.StatusResponse"
                      },
                      "GetCategories": {
                        "requestType": "squareup.onboard.activation.service.BusinessCategoriesRequest",
                        "responseType": "squareup.onboard.activation.service.BusinessCategoriesResponse"
                      },
                      "GetMerchantCategories": {
                        "requestType": "squareup.common.messages.Empty",
                        "responseType": "squareup.onboarding.business.common.GetMerchantCategoriesResponse"
                      },
                      "GetBusinessStructure": {
                        "requestType": "squareup.common.messages.Empty",
                        "responseType": "squareup.onboard.activation.service.GetBusinessStructureResponse"
                      },
                      "UpdateBusinessStructure": {
                        "requestType": "squareup.onboard.activation.service.UpdateBusinessStructureRequest",
                        "responseType": "squareup.onboard.activation.service.UpdateBusinessStructureResponse"
                      },
                      "BicPredict": {
                        "requestType": "squareup.onboarding.business.external.BicPredictRequest",
                        "responseType": "squareup.onboarding.business.BicPredictResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.UpdateRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.BicPredictRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.BusinessExternalService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateRequest @ squareup/onboarding/business/external.proto at 69:1
 */
export const UpdateRequest = $root.lookupType('squareup.onboarding.business.external.UpdateRequest');
fixType(UpdateRequest);
Builder.createAndAttachToType(UpdateRequest);
/**
 * SOURCE BicPredictRequest @ squareup/onboarding/business/external.proto at 82:1
 */
export const BicPredictRequest = $root.lookupType('squareup.onboarding.business.external.BicPredictRequest');
fixType(BicPredictRequest);
Builder.createAndAttachToType(BicPredictRequest);
/**
 * SOURCE BusinessExternalService @ squareup/onboarding/business/external.proto at 24:1
 */
export const BusinessExternalService = $root.lookupService('squareup.onboarding.business.external.BusinessExternalService');